<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div v-if="!loading && path.length" class="col-12">
          <gmap-map :center="center" :zoom="zoom" style="width: 100%; height: 500px" ref="map">
            <gmap-polyline v-if="path.length > 0" :path="path" ref="polyline" />
          </gmap-map>
        </div>
        <div class="col-12">
          <card class="card-plain" v-if="!loading && campaign">
            <template slot="header">
              <!-- <button @click="path = []" type="button" :class="['btn', 'btn-sm', 'mr-1', 'mb-1', 'btn-primary']">Loading</button> -->
              <!-- <button @click="decodePolyLines()" type="button" :class="['btn', 'btn-sm', 'mr-1', 'mb-1', 'btn-primary']">Decode</button> -->
              <h4 class="card-title mb-1">{{ campaign.name }}</h4>
              <p class="card-category mb-1">
                STARTS: {{ formatDate(campaign.startTime) }}. ENDS: {{ formatDate(campaign.endTime) }}. DATA AGE: {{  dataDate }}.
              </p>
              <br />
              <date-picker
                v-if="campaign.startTime && campaign.endTime"
                :startTime="campaign.startTime"
                :endTime="campaign.endTime"
                @date-range-selected="handleDateRange"
              ></date-picker>
              <br />
              <p class="card-category mb-1">SELECT DRIVER</p>
              <button
                v-for="(driver, index) in campaign.drivers"
                @click="toggleDriver(driver, index)"
                type="button"
                :class="[
                  'btn',
                  'btn-sm',
                  'mr-1',
                  'mb-1',
                  driver.fleet_id === selectedDriver ? 'btn-primary' : 'btn-secondary',
                ]"
              >
                {{ driver.name }}
              </button>
              <!-- <p class="card-category mb-1">Disabled Drivers: {{ disabledDrivers }}</p> -->
              <!-- <p class="card-category mb-1">Driver Distances: {{ driverDistances }}</p> -->
              <!-- <p class="card-category mb-1">Driver Distances: {{ polylines }}</p> -->
            </template>
            <div v-if="campaign && campaign.drivers && campaign.drivers.length" class="table-responsive">
              <c-table
                class="table-hover"
                :columns="tableColumns"
                :data="campaign.drivers"
                :driverDistances="driverDistances"
                :driverTimes="driverTimes"
              />
            </div>
          </card>
          <card v-else class="card-plain">
            <template slot="header">
              <h4 class="card-title">Loading Campaign...</h4>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable, connectFunctionsEmulator } from 'firebase/functions';
import { API_KEY } from './Maps/API_KEY';
import * as VueGoogleMaps from 'vue2-google-maps';
import Vue from 'vue';
Vue.use(VueGoogleMaps, {
  load: {
    key: API_KEY,
  },
});
import CTable from 'src/components/CampaignTable.vue';
import DatePicker from 'src/components/DatePicker.vue';
import Card from 'src/components/Cards/Card.vue';
import { decode } from '@googlemaps/polyline-codec';
const tableColumns = ['Driver', 'Distance', 'Time'];
export default {
  components: {
    CTable,
    DatePicker,
    Card,
  },
  props: {
    campaignId: String,
  },
  data() {
    return {
      loading: false,
      campaign: '',
      polylines: '',
      tableColumns: [...tableColumns],
      center: { lat: -28.64937, lng: 25.452929 },
      zoom: 5.5,
      path: [],
      driverDistances: {},
      driverTimes: {},
      limitDateRange: [],
      dataDate: '1000-01-01',
      selectedDriver: null,
    };
  },
  async created() {
    try {
      const app = getApp();
      const functions = getFunctions(app, 'europe-west1');
      // connectFunctionsEmulator(functions, "127.0.0.1", 5001);
      await this.getCampaign(functions);
      await this.getPolylineData(functions);
      await this.calculatesDistancesandTimes();
      // await this.decodePolyLines();
    } catch (error) {
      alert('Error querying API. Error: ' + error);
    }
  },
  methods: {
    async getCampaign(functions) {
      try {
        this.loading = true;
        const getCampaign = httpsCallable(functions, 'getCampaign');
        const getCampaignRes = await getCampaign({ campaignId: this.campaignId });
        this.campaign = getCampaignRes.data;
      } catch (error) {
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async getPolylineData(functions) {
      try {
        this.loading = true;
        const getPolylineDatas = httpsCallable(functions, 'getPolylineDatas', { timeout: 540000 });
        const getPolylineDatasRes = await getPolylineDatas({ campaignId: this.campaignId });
        Vue.set(this, 'polylines', getPolylineDatasRes.data);
      } catch (error) {
        console.log('getPolylineDataError', error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async calculatesDistancesandTimes() {
      try {
        this.loading = true;
        for (const polyline of this.polylines) {
          const initDate = new Date(this.dataDate);
          const polylineDate = new Date(polyline.date);
          if (initDate < polylineDate) this.dataDate = polyline.date;
          if (!this.driverDistances[polyline.fleet_id])
            Vue.set(this.driverDistances, polyline.fleet_id, polyline.distance);
          else this.driverDistances[polyline.fleet_id] += polyline.distance;

          if (!this.driverTimes[polyline.fleet_id]) Vue.set(this.driverTimes, polyline.fleet_id, polyline.seconds);
          else this.driverTimes[polyline.fleet_id] += polyline.seconds;
        }
      } catch (error) {
        console.error('calculatesDistancesandTimes', error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    async decodePolyLines() {
      try {
        this.loading = true;
        Vue.set(this, 'path', []);
        let pathArray = [];
        for (const polyline of this.polylines) {
          if (!polyline.polylines || !polyline.polylines.length) continue;
          if (polyline.fleet_id !== this.selectedDriver) continue;
          for (const polylineString of polyline.polylines) {
            const decodedArray = decode(polylineString, 5);
            for (const latlng of decodedArray) {
              const latlngObj = { lat: latlng[0], lng: latlng[1] };
              pathArray.push(latlngObj);
            }
          }
        }
        Vue.set(this, 'path', pathArray);
      } catch (error) {
        console.error('decodePolyLinesError', error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      try {
        const newDate = new Date(date * 1000);
        let year = newDate.getFullYear();
        let month = (newDate.getMonth() + 1).toString().padStart(2, '0'); // +1 because months are 0-indexed
        let day = newDate.getDate().toString().padStart(2, '0');

        return `${year}-${month}-${day}`;
      } catch (error) {
        console.log('formatDateError', error);
        return date;
      }
    },
    async toggleDriver(driverObj, index) {
      try {
        this.loading;
        this.selectedDriver = driverObj.fleet_id;
        await this.decodePolyLines();
      } catch (error) {
        console.error('toggleDriverError', error);
        alert('Toggle driver error. Error: ' + error);
      } finally {
        this.loading;
      }
    },
    async handleDateRange(dateRange) {
      Vue.set(this, 'limitDateRange', dateRange);
      await this.decodePolyLines();
    },
  },
};
</script>
<style></style>
